(function () {
    'use strict';

    function initPublicSellerInfiniteScroll() {
        var page = document.querySelector('[data-public-seller-page]');
        if (!page) return;

        var endpoint = page.getAttribute('data-cars-endpoint') || '';
        var wrapper = page.querySelector('[data-public-seller-cars]');
        var infinite = page.querySelector('[data-public-seller-infinite]');
        var sentinel = page.querySelector('[data-public-seller-sentinel]');
        var loading = page.querySelector('[data-public-seller-loading]');
        var loadMoreButton = page.querySelector('[data-public-seller-load-more]');
        if (!endpoint || !wrapper || !infinite || !sentinel) {
            initModelFilter();
            initRangeFilters();
            return;
        }

        var currentPage = parseInt(page.getAttribute('data-current-page') || '1', 10);
        var hasMore = page.getAttribute('data-has-more') === '1';
        var isLoading = false;
        var observer = null;
        var loadedCarIds = new Set();

        wrapper.querySelectorAll('.single-car[data-car-id]').forEach(function (card) {
            loadedCarIds.add(card.getAttribute('data-car-id'));
        });

        function initModelFilter() {
            var makeSelect = page.querySelector('#seller-filter-make');
            var modelSelect = page.querySelector('#seller-filter-model');
            var sortSelect = page.querySelector('#seller-filter-sort');
            if (!makeSelect || !modelSelect) return;

            var modelData;
            try {
                modelData = JSON.parse(page.getAttribute('data-model-options') || '{}');
            } catch (error) {
                modelData = {};
            }

            function updateModelOptions(makeValue) {
                var options = makeValue && modelData.by_make
                    ? (modelData.by_make[makeValue] || [])
                    : (modelData.all || []);
                var placeholder = modelSelect.getAttribute('data-placeholder') || '';

                if (modelSelect.selectize) {
                    var modelControl = modelSelect.selectize;
                    modelControl.clear(true);
                    modelControl.clearOptions();
                    modelControl.settings.placeholder = placeholder;
                    modelControl.updatePlaceholder();
                    modelControl.addOption(options.map(function (option) {
                        return {
                            value: option.value || '',
                            text: option.label || ''
                        };
                    }));
                    modelControl.refreshOptions(false);
                    if (options.length > 0) {
                        modelControl.enable();
                    } else {
                        modelControl.disable();
                    }
                    return;
                }

                modelSelect.innerHTML = '';
                var emptyOption = document.createElement('option');
                emptyOption.value = '';
                emptyOption.textContent = placeholder;
                modelSelect.appendChild(emptyOption);

                options.forEach(function (option) {
                    var element = document.createElement('option');
                    element.value = option.value || '';
                    element.textContent = option.label || '';
                    modelSelect.appendChild(element);
                });
                modelSelect.value = '';
                modelSelect.disabled = options.length === 0;
            }

            if (window.jQuery && typeof window.jQuery.fn.selectize === 'function') {
                var $ = window.jQuery;
                var selectizeConfig = {
                    plugins: ['clear_on_focus'],
                    maxOptions: 500,
                    searchField: ['text']
                };

                if (sortSelect && !sortSelect.selectize) {
                    $(sortSelect).selectize(selectizeConfig);
                }
                if (!modelSelect.selectize) {
                    $(modelSelect).selectize(selectizeConfig);
                }
                if (!makeSelect.selectize) {
                    $(makeSelect).selectize({
                        plugins: selectizeConfig.plugins,
                        maxOptions: selectizeConfig.maxOptions,
                        searchField: selectizeConfig.searchField,
                        onChange: updateModelOptions
                    });
                }
                return;
            }

            makeSelect.addEventListener('change', function () {
                updateModelOptions(makeSelect.value || '');
            });
        }

        function initRangeFilters() {
            if (!window.jQuery || typeof window.jQuery.fn.slider !== 'function') return;

            page.querySelectorAll('[data-range-filter]').forEach(function (range) {
                var slider = range.querySelector('[data-range-slider]');
                var fromInput = range.querySelector('[data-range-from]');
                var toInput = range.querySelector('[data-range-to]');
                var fromOutput = range.querySelector('[data-range-from-output]');
                var toOutput = range.querySelector('[data-range-to-output]');
                var min = parseInt(range.getAttribute('data-min') || '0', 10);
                var max = parseInt(range.getAttribute('data-max') || '0', 10);
                var step = parseInt(range.getAttribute('data-step') || '1', 10);
                var prefix = range.getAttribute('data-prefix') || '';
                if (!slider || !fromInput || !toInput || max <= min) {
                    range.classList.add('is-disabled');
                    return;
                }

                var selectedFrom = parseInt(fromInput.value, 10);
                var selectedTo = parseInt(toInput.value, 10);
                selectedFrom = Number.isFinite(selectedFrom) ? Math.max(min, Math.min(max, selectedFrom)) : min;
                selectedTo = Number.isFinite(selectedTo) ? Math.max(min, Math.min(max, selectedTo)) : max;
                if (selectedFrom > selectedTo) {
                    selectedFrom = min;
                    selectedTo = max;
                }

                function formatValue(value) {
                    return prefix + String(value).replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
                }

                function sync(values) {
                    fromInput.value = values[0] > min ? String(values[0]) : '';
                    toInput.value = values[1] < max ? String(values[1]) : '';
                    if (fromOutput) fromOutput.textContent = formatValue(values[0]);
                    if (toOutput) toOutput.textContent = formatValue(values[1]);
                }

                window.jQuery(slider).slider({
                    range: true,
                    min: min,
                    max: max,
                    step: Math.max(1, step),
                    values: [selectedFrom, selectedTo],
                    slide: function (event, ui) {
                        sync(ui.values);
                    },
                    change: function (event, ui) {
                        sync(ui.values);
                    }
                });
                sync([selectedFrom, selectedTo]);
            });
        }

        function setLoading(active) {
            if (loading) loading.classList.toggle('d-none', !active);
            if (loadMoreButton) loadMoreButton.disabled = active;
        }

        function finish() {
            infinite.classList.toggle('d-none', !hasMore);
            if (!hasMore && observer) observer.disconnect();
        }

        function appendCars(html) {
            var container = document.createElement('div');
            container.innerHTML = html || '';
            var added = 0;

            container.querySelectorAll('.single-car[data-car-id]').forEach(function (card) {
                var carId = card.getAttribute('data-car-id');
                if (!carId || loadedCarIds.has(carId)) return;
                loadedCarIds.add(carId);
                wrapper.appendChild(card);
                added += 1;
            });

            if (added > 0 && window.CarBuyFavorites && typeof window.CarBuyFavorites.sync === 'function') {
                window.CarBuyFavorites.sync(wrapper);
            }

            return added;
        }

        function showRetry() {
            if (!loadMoreButton) return;
            loadMoreButton.textContent = infinite.getAttribute('data-retry-label') || 'Retry';
            loadMoreButton.classList.remove('d-none');
        }

        function loadNextPage() {
            if (isLoading || !hasMore) return;
            isLoading = true;
            setLoading(true);
            if (loadMoreButton) loadMoreButton.classList.add('d-none');

            var payload = { page: currentPage + 1 };
            new URLSearchParams(window.location.search).forEach(function (value, key) {
                if (key !== 'page') payload[key] = value;
            });

            function finishRequest() {
                isLoading = false;
                setLoading(false);
            }

            function failRequest() {
                if (observer) observer.disconnect();
                showRetry();
                finishRequest();
            }

            if (typeof window.csrfSafeAjaxPost !== 'function') {
                failRequest();
                return;
            }

            window.csrfSafeAjaxPost(
                endpoint,
                payload,
                function (response) {
                    if (!response || response.success !== true) {
                        failRequest();
                        return;
                    }

                    var added = appendCars(response.html);
                    currentPage = parseInt(response.current_page, 10) || (currentPage + 1);
                    hasMore = response.has_more === true && added > 0;
                    page.setAttribute('data-current-page', String(currentPage));
                    page.setAttribute('data-has-more', hasMore ? '1' : '0');
                    finish();
                    if (hasMore && observer) observer.observe(sentinel);
                },
                failRequest,
                finishRequest
            );
        }

        if (loadMoreButton) {
            loadMoreButton.addEventListener('click', function () {
                loadNextPage();
            });
        }

        initModelFilter();
        initRangeFilters();

        if ('IntersectionObserver' in window) {
            observer = new IntersectionObserver(function (entries) {
                if (entries.some(function (entry) { return entry.isIntersecting; })) {
                    loadNextPage();
                }
            }, { rootMargin: '600px 0px' });
            observer.observe(sentinel);
        } else if (loadMoreButton) {
            loadMoreButton.classList.remove('d-none');
        }

        finish();
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initPublicSellerInfiniteScroll);
    } else {
        initPublicSellerInfiniteScroll();
    }
})();
